// extracted by mini-css-extract-plugin
export default {"MenuItem":"MenuItem_MenuItem__3+P7L","MenuItem__DropdownItem__link":"MenuItem_MenuItem__DropdownItem__link__tkAfQ","spin":"MenuItem_spin__jm75s"};